import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LableIconNav from "./LableIconNav";
import OnlyLableNav from "./OnlyLableNav";
import IconToggelNav from "./IconToggelNav";
import MenuDropdownNav from "./MenuDropdownNav";
import HoverListingNav from "./HoverListingNav";

const NavbarInner = (props) => {
    const navigate = useNavigate();
    let token = window.localStorage.getItem("user_token");
    let deviceType = localStorage.getItem("device_type");
    const dropdownRef = useRef(null);

    const { playerMenu, componentSetting, providerSubMenuList } = useSelector((state) => ({
        componentSetting: state.componentSettingListR.data,
        providerSubMenuList: state.submenuListR.data,
        playerMenu: state.menuListR.data,
    }));


    const [loggedIn, setLoggedIn] = useState("");
    const [menuList, setMenuList] = useState([]);
    const [openDrop, setOpenDrop] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleToggleDropdown = (code) => {
        setOpenDrop(code);
        setIsDropdownOpen((prevIsDropdownOpen) =>
            code !== openDrop ? true : !prevIsDropdownOpen
        );
    };

    const handleClose = (code, submenu) => {
        setIsDropdownOpen(false);
        if (!submenu) setOpenDrop(code);
        if (code) {
            if (code == "hkb-transactions") {
                props.handlePopupClose();
                return;
            }
            navigate(`/${code}`);
        }
    };

    const outSideClickClose = (event) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target) &&
            !event.target.classList.contains("dropdown-content") &&
            !event.target.closest(".dropdown-content") &&
            event.target.getAttribute("data-dropdown") !== "true"
        ) {
            setIsDropdownOpen(false);
            setOpenDrop("");
        }
    };

    useEffect(() => {
        if (playerMenu) {
            let menuListToSet;

            if (!loggedIn) {
                menuListToSet = playerMenu["before"];
            } else {
                menuListToSet = playerMenu["after"];
            }

            const menuArray = menuListToSet && Object.values(menuListToSet);
            menuArray && menuArray.sort((a, b) => parseInt(a.order) - parseInt(b.order));
            const sortedMenuObject = menuArray && menuArray.reduce((acc, item) => {
                acc[item.code] = item;
                return acc;
            }, {});

            //only remove hkb-transactions from dropdown
            const removeHkbTransactions = Object.fromEntries(
                Object.entries(sortedMenuObject).filter(([key]) => key !== "hkb-transactions")
            );
            setMenuList(removeHkbTransactions);
            // setMenuList(sortedMenuObject);
        }
    }, [loggedIn, playerMenu]);

    useEffect(() => {
        setLoggedIn(token);
    }, [token]);

    useEffect(() => {
        document.addEventListener("mousedown", outSideClickClose);

        return () => {
            document.removeEventListener("mousedown", outSideClickClose);
        };
    }, []);
    return (
        <>
            {menuList && Object.values(menuList).map((v, i) => {
                let customLink = '';
                if (v.code === 'home') {
                    customLink = '';
                } else if (v.code === 'my-referral') {
                    customLink = 'referral';
                } else if (
                    ["trans_history",
                        "outstanding_bet",
                        "card_games",
                        "live_casino",
                        "jackpot_bar",
                        "all_games",
                        "about_us",
                        "terms_and_conditions"
                    ].includes(v.code)) {
                    v.code = v.code.replace(/_/g, '-');
                } else {
                    customLink = v?.code;
                }
                return (
                    <React.Fragment key={i}>
                        {!v.footer_menu && (v.location === "menu" || v.location === "sub_menu") && v.status && v.code != 'live-chat' &&
                            <>
                                {componentSetting?.["horizonatal-nav-bar"]?.["default-value"] === "label-icon" && (
                                    <LableIconNav
                                        t={props.t}
                                        i={i}
                                        v={v}
                                        menuList={menuList}
                                        ftpPath={playerMenu?.ftp_path}
                                        mouseOver={props?.mouseOver}
                                        customLink={customLink}
                                    />
                                )}

                                {componentSetting?.["horizonatal-nav-bar"]?.["default-value"] == "only-lable" && (
                                    <OnlyLableNav
                                        t={props.t}
                                        i={i}
                                        v={v}
                                        menuList={menuList}
                                        ftpPath={playerMenu?.ftp_path}
                                        mouseOver={props?.mouseOver}
                                        customLink={customLink}
                                    />
                                )}
                                {componentSetting["horizonatal-nav-bar"]["default-value"] == "icon-toggel" && (
                                    <IconToggelNav
                                        t={props.t}
                                        i={i}
                                        v={v}
                                        menuList={menuList}
                                        ftpPath={playerMenu?.ftp_path}
                                        mouseOver={props?.mouseOver}
                                        customLink={customLink}
                                    />
                                )}

                                {componentSetting?.["horizonatal-nav-bar"]?.["default-value"] == "hover-listing" && (
                                    <HoverListingNav
                                        t={props.t}
                                        i={i}
                                        v={v}
                                        menuList={menuList}
                                        ftpPath={playerMenu?.ftp_path}
                                        mouseOver={props?.mouseOver}
                                        customLink={customLink}
                                        providerSubMenuList={providerSubMenuList}
                                        deviceType={deviceType}
                                    />
                                )}

                                {componentSetting?.["horizonatal-nav-bar"]?.["default-value"] == "menu-dropdown" && (
                                    <MenuDropdownNav
                                        t={props.t}
                                        i={i}
                                        v={v}
                                        menuList={menuList}
                                        ftpPath={playerMenu?.ftp_path}
                                        mouseOver={props?.mouseOver}
                                        customLink={customLink}
                                        providerSubMenuList={providerSubMenuList}
                                        deviceType={deviceType}
                                        isDropdownOpen={isDropdownOpen}
                                        handleToggleDropdown={handleToggleDropdown}
                                        componentSetting={componentSetting}
                                        openDrop={openDrop}
                                        handleClose={handleClose}
                                        dropdownRef={dropdownRef}

                                    />
                                )}
                            </>
                        }
                    </React.Fragment>
                )
            })}
        </>
    );
};

NavbarInner.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(NavbarInner);
